"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _index = _interopRequireDefault(require("./index.style"));
const ListItemText = props => {
  const {
    children = '',
    className,
    ...others
  } = props;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_ListItemText.default, (0, _extends2.default)({
    disableTypography: true
  }, others, {
    className: (0, _clsx.default)(classes.listItem, className)
  }), children);
};
var _default = exports.default = ListItemText;